"use client";

import { useQuery } from "@tanstack/react-query";
import React from "react";
import Markdown from "react-markdown";

import FetchError from "@/components/ui/fetch-error";
import Loading from "@/components/ui/loading";
import { FAQProps } from "@/types";
import Accordion from "react-bootstrap/Accordion";

import api from "@/lib/api";

export default function FAQList() {
  const {
    data: tutorials = [],
    error,
    isPending,
  } = useQuery({
    queryKey: ["faqs-hcap"],
    queryFn: () => api.get<FAQProps[]>("/cms/faqs/hcap/"),
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  return (
    <Accordion>
      {tutorials.map((tutorial, index) => (
        <Accordion.Item key={index} eventKey={`${index}`}>
          <Accordion.Header>{tutorial.question}</Accordion.Header>
          <Accordion.Body>
            <Markdown>{tutorial.content}</Markdown>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
